import { render, staticRenderFns } from "./AiWidget.vue?vue&type=template&id=c886cfb2&scoped=true"
import script from "./AiWidget.vue?vue&type=script&lang=js"
export * from "./AiWidget.vue?vue&type=script&lang=js"
import style0 from "./AiWidget.vue?vue&type=style&index=0&id=c886cfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c886cfb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
